/**
 * Offline sync queue types.
 *
 * @author Milton Filho
 */

export enum OfflineActionKind {
  StartSession = 'StartSession',
  BookAppointment = 'BookAppointment',
}

export interface OfflineQueueItem {
  /** Unique identifier for this queue item */
  id: string;
  /** The kind of offline action queued */
  kind: OfflineActionKind;
  /** Original API payload to replay on sync */
  payload: Record<string, unknown>;
  /** Temp appointment IDs created for optimistic updates */
  tempAppointmentIds: number[];
  /** ISO timestamp of when the item was enqueued */
  createdAt: string;
  /** ISO timestamp of when the item failed to sync (if applicable) */
  failedAt?: string;
}

export interface OfflineSyncState {
  /** Ordered queue of items pending sync */
  queue: OfflineQueueItem[];
  /** Appointment IDs currently pending sync (positive for arrive, negative for bookings) */
  pendingIds: number[];
  /** Decrementing counter for generating temp negative IDs */
  tempIdCounter: number;
  /** Current sync status */
  syncStatus: 'idle' | 'syncing';
}
